export const lightTheme = {
  name: 'light',
  dark: false,
  colors: {
    // primary: '#007bff',
    primary: '#172b4d',
    secondary: '#6c757d',
    hovered: '#172b4d',
    expand: '#5b6574',
    // border: '#091E420F',
    border: '#ccc',
    link: '#0052CC',
    inputBorder: '#dddfe5', // trello color
    subtleLink: 'var(--ds-text-subtle,#6B778C)  !important',
    // other light theme color definitions
  },
  bgColors: {
    primary: '#fff',
    select: '#091E420F',
    // primary: 'red',
    secondary: '#f8f9fa',
    // secondary: '#323940',
    hovered: '#eaecef',
    expand: '#c6cfdd',
    expandHover: '#d1d9e5',
    button: '#091E420F',
    surfaceOverlay: '#FFFFFF',

    // inputBorder: '#dddfe5', // trello color
    // other light theme color definitions
  },
  button: {
    background: '#0079bf',
    hovered: '#f7f8f9',
    pressed: '#fafbfc',
    border: '#dddfe5', // trello color
    borderSelected: '#a6c5e250',
    borderFocused: '#a6c5e250',
    boxShadowError: 'inset 0 0 0 2px #eb5a46 !important',
    boxShadow: 'inset 0 0 0 2px #dfe1e5',
    boxShadowFocused: 'inset 0 0 0 2px #cfcfcf',
    boxShadowHovered: 'inset 0 0 0 2px #cfcfcf',
  },
  checkbox: {
    background: '#fafbfc', // trello color
    boxShadow: 'inset 0 0 0 2px #dfe1e5',
    disabled: '#d1d1d1',
  },
  input: {
    background: '#fafbfc',
    hovered: '#f7f8f9',
    focused: '#f7f8f9',
    darkerHovered: '#e6e8eb',
    pressed: '#fafbfc',
    disabled: '#fafbfc',
    border: '#dddfe5', // trello color
    borderSelected: '#a6c5e250',
    borderFocused: '#a6c5e250',
    boxShadowError: 'inset 0 0 0 2px #eb5a46 !important',
    boxShadow: 'inset 0 0 0 2px #dfe1e5',
    boxShadowFocused: 'inset 0 0 0 2px #cfcfcf',
    boxShadowHovered: 'inset 0 0 0 2px #cfcfcf',
  },
  // other light theme properties
};

export const darkTheme = {
  name: 'dark',
  dark: true,
  colors: {
    primary: '#b6c2cf',
    // primary: '#172b4d',
    // secondary: '#bdbdbd',
    secondary: '#808080',
    hovered: '#0052cc',
    expand: '#c6cfdd',
    link: '#579dff',
    subtleLink: 'var(--ds-text-subtle,#6B778C)  !important',
    border: '#a1bdd9',

    // #dfe1e5
    // inputBorder: 'rgb(38, 132, 255)',
    // other dark theme color definitions
  },
  bgColors: {
    // primary: '#161a1d',
    primary: '#323940', // from trello card back
    // secondary: '#22272b',
    secondary: 'rgba(50, 57, 64, 0.4)',
    hovered: '#22272b',

    // primary: 'blue',
    select: '#A1BDD914',
    expand: '#5b6574',
    expandHover: '#7186A5',
    button: '#A1BDD914',
    surfaceOverlay: '#282e33',
    // other dark theme color definitions
  },
  button: {
    primary: '#579DFF',
    // secondary: '#6c757d',
    // expand: '#5b6574',
    // // border: '#091E420F',
    // border: '#A6C5E229',
    // // other light theme color definitions
    // button: '#fafbfc',
    background: '#172b4d',
    hovered: '#f7f8f9',
    pressed: '#fafbfc',
    border: '#dddfe5', // trello color
    borderSelected: '#a6c5e250',
    borderFocused: '#a6c5e250',
    boxShadowError: 'inset 0 0 0 2px #eb5a46 !important',
    boxShadow: 'inset 0 0 0 2px #dfe1e5',
    boxShadowFocused: 'inset 0 0 0 2px #cfcfcf',
    boxShadowHovered: 'inset 0 0 0 2px #cfcfcf',
  },
  checkbox: {
    background: '#1d2125', // trello color
    boxShadow: 'inset 0 0 0 2px #2d363d',
    disabled: '#46505a', // trello color
  },
  input: {
    background: '#a1bdd914',
    second: '#a1bdd914', // trello color
    // background: '#a1bdd914', // own
    hovered: '#22272b', // trello color
    darkerHovered: '#a1bdd914',
    pressed: '#1d2125', // trello color
    disabled: '#46505a', // trello color
    // focused: '#1d2125', // trello color
    focused: '#22272b',
    // border: '#0079bf', // trello color
    border: '#a6c5e220',
    borderSelected: '#a6c5e250',
    borderFocused: '#a6c5e250',
    boxShadowError: 'inset 0 0 0 2px #eb5a46 !important',
    boxShadow: 'inset 0 0 0 2px #a6c5e220',
    boxShadowFocused: 'inset 0 0 0 2px #a6c5e260',
    boxShadowHovered: 'inset 0 0 0 2px #a6c5e260',
  },
  // other dark theme properties
};

export default {
  light: lightTheme,
  dark: darkTheme,
};
